import { ListGroupItem } from "react-bootstrap";
import { Link } from "react-router-dom";
import type { InsightsController } from "../../../api/src/insights/insights.controller";
import type { UnpackResponse } from "../../../api/src/lib";
import Loading from "../Loading";
import InsightFailed from "./InsightFailed";
import { useAuthenticatedQuery } from "../lib/api";

function useQueryUnknownTaxClassificationInsight() {
  return useAuthenticatedQuery<
    UnpackResponse<InsightsController["unknownTaxClassification"]>,
    number[],
    [string, string]
  >({
    queryKey: ["insights", "unknown-tax-classification"],
    queryFn: async (unknownTaxClassification) => unknownTaxClassification.data,
  });
}

const UnknownTaxClassification = () => {
  const { isPending, data } = useQueryUnknownTaxClassificationInsight();

  if (isPending) {
    return (
      <ListGroupItem>
        <Loading />
      </ListGroupItem>
    );
  }

  if (typeof data === "undefined") {
    return <InsightFailed />;
  }

  if (data.length <= 0) {
    return null;
  }

  return (
    <ListGroupItem>
      There are{" "}
      <Link to="/clients/accounts/tax-classification">
        {data.length} accounts with unknown tax classification
      </Link>{" "}
      in your firm.
    </ListGroupItem>
  );
};

export default UnknownTaxClassification;
